//
// Generated class Asset
//

/// <reference path="Asset_ManagedObject.ts" />

class Asset extends Asset_ManagedObject
{

}
